// import qs from 'qs';
import client from './client';

export default {
  async getCarousel() {
    const response = await client.get('dashboard/carousel/');
    return response.data;
  },
};
